import { render, staticRenderFns } from "./ExpandableList.vue?vue&type=template&id=2973e5ee&scoped=true"
import script from "./ExpandableList.vue?vue&type=script&lang=ts"
export * from "./ExpandableList.vue?vue&type=script&lang=ts"
import style0 from "./ExpandableList.vue?vue&type=style&index=0&id=2973e5ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2973e5ee",
  null
  
)

export default component.exports